export default __webpack_public_path__ + "static/media/Message.74b2390d.svg";